'use client'

import { useMemo, useState } from 'react'
import { ToolField, ToolResultCard, ToolResultRow, toolCurrency, toolFmt, toolNum } from './tool-inputs'

// Crushed stone / gravel bulk density ≈ 1.5 t/m³.
const GRAVEL_DENSITY_T_PER_M3 = 1.5

export function GravelCalculatorTool() {
  const [length, setLength] = useState('5')
  const [width, setWidth] = useState('3')
  const [depth, setDepth] = useState('50')
  const [price, setPrice] = useState('350')

  const r = useMemo(() => {
    const area = toolNum(length) * toolNum(width)
    const volume = area * (toolNum(depth) / 1000)
    const tonnes = volume * GRAVEL_DENSITY_T_PER_M3
    return { area, volume, tonnes, bulkBags: Math.ceil(tonnes), cost: tonnes * toolNum(price) }
  }, [length, width, depth, price])

  return (
    <div className="grid gap-6 md:grid-cols-[1fr_380px] md:items-start">
      <div className="space-y-5 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Area &amp; depth</h2>
          <div className="mt-3 grid grid-cols-3 gap-3">
            <ToolField label="Length" value={length} onChange={setLength} unit="m" />
            <ToolField label="Width" value={width} onChange={setWidth} unit="m" />
            <ToolField label="Depth" value={depth} onChange={setDepth} unit="mm" step="5" hint="50 mm typical" />
          </div>
        </div>
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Price</h2>
          <div className="mt-3 grid grid-cols-2 gap-3">
            <ToolField label="Gravel price" value={price} onChange={setPrice} unit="R/tonne" />
          </div>
        </div>
      </div>

      <ToolResultCard title="Your gravel estimate">
        <ToolResultRow label="Area" value={`${toolFmt(r.area, 1)} m²`} />
        <ToolResultRow label="Volume" value={`${toolFmt(r.volume, 2)} m³`} />
        <ToolResultRow label="Gravel needed" value={`${toolFmt(r.tonnes, 2)} t`} />
        <ToolResultRow label="≈ bulk bags (1 t)" value={`${r.bulkBags} bags`} />
        <ToolResultRow label="Estimated gravel cost" value={toolCurrency(r.cost)} strong />
      </ToolResultCard>
    </div>
  )
}
